import React, { Component } from 'react';
import classes from "./Intro.module.css";

export default class Intro extends Component {

    render() {
        // const { data, labels } = this.state;
        return (
            <div className={classes.container}>
                <h4>Dashboard and Analysis</h4>
                <p className="text-anal">There have been numerous <a href="https://www.nytimes.com/2020/04/07/arts/animal-crossing-covid-coronavirus-popularity-millennials.html" target="_blank">articles</a> of how Social Distancing has influenced people to start playing video games to relieve stress; one case in point is Animal Crossing. The game has cheerful colors, harmonious music, and engaging characters, and the daily game play of upgrading your village is quite relaxing and soothing. In this study, we will look at other particular details [such as Collecting furniture and the Villagers' personality, gender, and species] that make this game so much fun and sought after!</p>
        
                <p className="text-anal">This webpage was created using (1) python (Pandas, Numpy, Beautiful Soup packages) to scrape and clean the data, (2) Leaflet and OpenStreetMap for the map, and (3) react, fontawesome, Chart.js, and D3.js for the User Interface (UI), design, and charts.</p> 
            
                <p className="text-anal">In Extract, Transform, and Load (ETL) context, python is used for Extraction and Transform; javascript is used for Load.</p>
            
            </div>
        )
    }
}

/* Tutorial from:
     https://blog.bitsrc.io/customizing-chart-js-in-react-2199fa81530a
*/